// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"498":"bookonline","862":"booking","999":"bookingdetails"}[chunkId] + "." + {"498":"988a7174","862":"20ac56dd","999":"e719050f"}[chunkId] + ".css";
};